function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import { guid } from '@bydesign-ui/utils';
import { Emitter } from '@bydesign-ui/hooks';
import { TreeMapData } from '../../../models/tree-map';
export var RowGroup = function (_Emitter) {
  _inherits(RowGroup, _Emitter);

  var _super = _createSuper(RowGroup);

  function RowGroup(table) {
    var _this;

    _classCallCheck(this, RowGroup);

    _this = _super.call(this);
    _this.id = guid();
    _this.expandedRowKeyMap = {};
    _this.expandedRows = [];
    _this.table = table;
    var rowKey = table.getRowKey();
    _this.map = new TreeMapData(function (datasource) {
      return datasource[rowKey];
    }, function (datasource) {
      return String(datasource[rowKey]);
    });
    return _this;
  }

  _createClass(RowGroup, [{
    key: "updateRowGroup",
    value: function updateRowGroup(options) {
      var expandedRowKeys = options.expandedRowKeys;
      var expandedRowKeyMap = {};
      var map = this.map;
      map.updateTreeMapDataOptions(options);
      expandedRowKeys.forEach(function (value) {
        var _map$getItemInfo = map.getItemInfo(map.getIdByValue(value)),
            nodePath = _map$getItemInfo.nodePath;

        nodePath.forEach(function (id) {
          return expandedRowKeyMap[id] = true;
        });
      });
      this.expandedRowKeyMap = expandedRowKeyMap;
      this.expandedRows = expandedRowKeys;
    }
  }, {
    key: "getRenderRows",
    value: function getRenderRows() {
      var expandedRowKeyMap = this.expandedRowKeyMap;
      var map = this.map;
      var stack = [0];
      return map.getRenderList().filter(function (item) {
        return item.level === 1 || expandedRowKeyMap[item.parentId];
      }).map(function (item, index) {
        var _a;

        var id = item.id,
            isLeaf = item.isLeaf,
            level = item.level;
        stack.length = level;
        stack[level - 1] = ((_a = stack[level - 1]) !== null && _a !== void 0 ? _a : 0) + 1;
        return {
          id: id,
          isLeaf: isLeaf,
          level: level,
          expanded: expandedRowKeyMap[id],
          row: item.item,
          index: index,
          serials: stack.slice()
        };
      });
    }
  }, {
    key: "setRowExpand",
    value: function setRowExpand(id, expanded) {
      var map = this.map;
      var info = map.getItemInfo(id);

      if (this.expandedRowKeyMap[id] !== expanded) {
        var list = this.expandedRows.slice(0);
        var value = this.map.getItemInfo(id).value;

        for (var i = list.length - 1; i >= 0; i--) {
          if (map.getItemInfo(map.getIdByValue(list[i])).nodePath.indexOf(id) >= 0) {
            list.splice(i, 1);
          }
        }

        if (expanded) {
          list.push(value);
        } else if (info.level > 1) {
          list.push(map.getItemInfo(info.parentId).value);
        }

        this.emit('expanded-change', list);
      }
    }
  }]);

  return RowGroup;
}(Emitter);